import { useFeatureIsOn } from '../contexts/growthbook';
import {
  IGiftItemBanner,
  IPrismicGiftItemBannerContent,
  IPrismicGiftItemBannerResult,
} from '@monofront/types';
import { createContext, useEffect, useState } from 'react';
interface IGiftItemBannerProviderProps {
  contents: IPrismicGiftItemBannerResult[];
  children: React.ReactNode;
}

const GiftItemBannerContext = createContext<{
  contents: IPrismicGiftItemBannerContent[];
}>({
  contents: [],
});

const GiftItemBannerProvider: React.FC<IGiftItemBannerProviderProps> = ({
  children,
  contents,
}) => {
  const [stateContents, setStateContents] = useState<
    IPrismicGiftItemBannerContent[]
  >([]);

  const mapGiftItemBanner = (
    prismicContent: IPrismicGiftItemBannerResult,
  ): IGiftItemBanner => {
    return {
      giftItemBanner: prismicContent.data.body[0]?.items ?? [],
      abtestBanner: prismicContent.data.body1[0]?.items ?? [],
      abtestEnabled: !!prismicContent.data.isgiftitembanneractive,
    };
  };

  const giftItemBannerContent = contents?.find(
    (content) => content?.data?.isgiftitembanneractive !== undefined,
  );

  const isVariant = useFeatureIsOn(
    giftItemBannerContent?.data?.feature_flag_key || '',
  );

  useEffect(() => {
    if (!contents || !contents.length || !giftItemBannerContent) {
      return;
    }

    const { abtestBanner, giftItemBanner, abtestEnabled } = mapGiftItemBanner(
      giftItemBannerContent,
    );

    if (isVariant && abtestEnabled) {
      setStateContents(abtestBanner);

      return;
    }
    if (giftItemBanner && (!abtestEnabled || !isVariant)) {
      setStateContents(giftItemBanner);
    }
  }, [contents, isVariant]);

  return (
    <GiftItemBannerContext.Provider value={{ contents: stateContents }}>
      {children}
    </GiftItemBannerContext.Provider>
  );
};

export { GiftItemBannerContext, GiftItemBannerProvider };
